import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, MailCheck, XCircle } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ busy: true });
  const { refreshUser } = useAuth();
  useEffect(() => {
    api.post("/auth/verify-email", { token: params.get("token") || "" })
      .then(() => { setState({ ok: true }); refreshUser?.().catch?.(() => {}); })
      .catch((e) => setState({ error: formatErr(e) }));
  }, [params]);
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-rose-50/40">
      <div className="max-w-sm w-full bg-white rounded-3xl border border-pink-100 p-8 text-center space-y-3" data-testid="verify-email-page">
        {state.busy ? <Loader2 className="w-8 h-8 animate-spin text-rose-500 mx-auto" /> : state.ok ? (
          <><MailCheck className="w-12 h-12 text-emerald-500 mx-auto" /><p className="font-display text-2xl font-extrabold" data-testid="verify-email-ok">E-Mail bestätigt! 💖</p><p className="text-sm text-slate-500">Danke – dein Konto ist jetzt komplett.</p></>
        ) : (
          <><XCircle className="w-12 h-12 text-red-400 mx-auto" /><p className="font-bold" data-testid="verify-email-error">{state.error}</p></>
        )}
        {!state.busy && <Link to="/feed" data-testid="verify-email-continue" className="inline-flex h-11 px-6 items-center rounded-full pink-gradient text-white font-bold">Zur Community</Link>}
      </div>
    </div>
  );
}
